import React, { Component } from 'react';
import {
  BrowserRouter as Router,
  Route,
  Switch,
} from 'react-router-dom';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './screens/Home';
import AboutUs from './screens/AboutUs';
import Enquire from './screens/Enquire';
import Business from './screens/Business';
import Premium from './screens/Premium'
import PrivacyPolicy from './screens/PrivacyPolicy';
import Disclaimer from './screens/Disclaimer';
import Downloads from './screens/Downloads';
import { OurTeam, Paul, Ahmad, Christopher, Khoo } from './screens/OurTeam';

class App extends Component {
  render() {
    return (
      <Router>
        <Switch>
          <Route path="/our-team/paul-kuan" component={Paul} />
          <Route path="/our-team/ahmad-kamal" component={Ahmad} />
          <Route path="/our-team/christopher-koh" component={Christopher} />
          <Route path="/our-team/khoo-khay-teik" component={Khoo} />
          <Route path="/privacy-policy" key="privacy" component={PrivacyPolicy} />
          <Route path="/disclaimer" key="disclaimer" component={Disclaimer} />
          <Route render={({ location, history }) => (
            <div>
              <Navbar location={location} history={history} />
              <CSSTransitionGroup
                transitionName="fade"
                transitionEnterTimeout={300}
                transitionLeaveTimeout={300}
              >
                <Route key={location.key} location={location} render={() => (
                  <div>
                    <Route exact path="/" key="home" location={this._prevLocation} component={Home} />
                    <Route path="/about-us" key="about" location={this._prevLocation} history={history} component={AboutUs}/>
                    <Route path="/our-team" key="team" location={this._prevLocation} component={OurTeam} />
                    <Route path="/products/business-financing" key="business" location={this._prevLocation} component={Business} />
                    <Route path="/products/premium-financing" key="premium" location={this._prevLocation} component={Premium} />
                    <Route path="/contact-us" key="enquiry" location={this._prevLocation} component={Enquire} />
                    <Route path="/downloads" key="downloads" location={this._prevLocation} component={Downloads} />
                  </div>
                )} />
              </CSSTransitionGroup>
              <Footer />
            </div>
          )}/>
        </Switch>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js